import { render } from "./ProjectItem.vue?vue&type=template&id=cc4962f4"
import script from "./ProjectItem.vue?vue&type=script&lang=js"
export * from "./ProjectItem.vue?vue&type=script&lang=js"

import "./ProjectItem.vue?vue&type=style&index=0&id=cc4962f4&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__